import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Training = lazy(() => import('../pages/training/page'));
const Training2026 = lazy(() => import('../pages/training/2026/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/training',
    element: <Training />,
  },
  {
    path: '/training/2026',
    element: <Training2026 />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
